import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll
} from "body-scroll-lock";

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('#achsspannervideo').length > 0) {
    let time;
    let vid = document.getElementById("achsspannervideo");

    vid.load();
    vid.pause();


    window.addEventListener("resize", resizefunction);

    resizefunction();

    document.querySelector("#komponenten .buttonholder").classList.remove('show');

    function resizefunction() {
      let leftbase = document.querySelector('#achsspannervideo').clientWidth / 2;
      let topbase = document.querySelector('#achsspannervideo').clientHeight / 2;
      let technologypos = {x: 100, y: -275};
      let steifigkeitpos = {x: -275, y: -135};
      let spannbereichpos = {x: 250, y: -150};
      let grundkoerperpos = {x: 50, y: -75};
      let automationpos = {x: -200, y: 50};
      let nullpunktspannsyspos = {x: 125, y: 175};

      let movefactor = 1;

      if (document.querySelector('#achsspannervideo').clientHeight <= document.querySelector('#achsspannervideo').clientWidth) {
        movefactor = document.querySelector('#achsspannervideo').clientWidth / 1920;
      } else {
        movefactor = document.querySelector('#achsspannervideo').clientHeight / 1920;
      }

      document.querySelector("button[data-target=technology]").style.left = (leftbase + movefactor * technologypos.x) + 'px';
      document.querySelector("button[data-target=technology]").style.top = (topbase + movefactor * technologypos.y) + 'px';
      document.querySelector("button[data-target=steifigkeit]").style.left = (leftbase + movefactor * steifigkeitpos.x) + 'px';
      document.querySelector("button[data-target=steifigkeit]").style.top = (topbase + movefactor * steifigkeitpos.y) + 'px';
      document.querySelector("button[data-target=spannbereich]").style.left = (leftbase + movefactor * spannbereichpos.x) + 'px';
      document.querySelector("button[data-target=spannbereich]").style.top = (topbase + movefactor * spannbereichpos.y) + 'px';
      document.querySelector("button[data-target=grundkoerper]").style.left = (leftbase + movefactor * grundkoerperpos.x) + 'px';
      document.querySelector("button[data-target=grundkoerper]").style.top = (topbase + movefactor * grundkoerperpos.y) + 'px';
      document.querySelector("button[data-target=automation]").style.left = (leftbase + movefactor * automationpos.x) + 'px';
      document.querySelector("button[data-target=automation]").style.top = (topbase + movefactor * automationpos.y) + 'px';
      document.querySelector("button[data-target=nullpunktspannung]").style.left = (leftbase + movefactor * nullpunktspannsyspos.x) + 'px';
      document.querySelector("button[data-target=nullpunktspannung]").style.top = (topbase + movefactor * nullpunktspannsyspos.y) + 'px';
    }


    let achsspannervideooptions = {
      rootMargin: '0px',
      threshold: 0.5
    };

    let introlength = 2;




    let introplayed = false;

    let achsspannervideoobserver = new IntersectionObserver(achsspannervideocallback, achsspannervideooptions);

    let achsspannervideotarget = document.querySelector('#achsspannervideo');
    achsspannervideoobserver.observe(achsspannervideotarget);


    function eventlistenerintroplayed() {
      if (vid.currentTime >= introlength) {
        removePlaylisterns();
        vid.pause();
        setTimeout(function () {
          document.querySelector("#komponenten .buttonholder").classList.add('show');
        }, 200);
      }
    }


    function achsspannervideocallback(entries, observer) {
      entries.forEach(entry => {

          if (entry.isIntersecting) {
            if (!introplayed) {
              vid.addEventListener('timeupdate', eventlistenerintroplayed);
              vid.play();
              introplayed = true;
            }
          }
        }
      )
    };

    function removePlaylisterns() {
      vid.removeEventListener('timeupdate', eventlistenerintroplayed);
      vid.removeEventListener('timeupdate', eventlistenerTechnologyINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerTechnologyOUTPlayed);
      vid.removeEventListener('timeupdate', eventlistenerSteifigkeitINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerSteifigkeitOUTPlayed);
      vid.removeEventListener('timeupdate', eventlistenerSpannbereichINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerSpannbereichOUTPlayed);
      vid.removeEventListener('timeupdate', eventlistenerGrundkoerperINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerGrundkoerperOUTPlayed);
      vid.removeEventListener('timeupdate', eventlistenerAutomationINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerAutomationOUTPlayed);
      vid.removeEventListener('timeupdate', eventlistenerNullpunktspannungINPlayed);
      vid.removeEventListener('timeupdate', eventlistenerNullpunktspannungOUTPlayed);
    }

    /* technology */

    document.querySelector("button[data-target=technology]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 2;
        vid.addEventListener('timeupdate', eventlistenerTechnologyINPlayed);
        vid.play();
        vid.classList.add('zoom');

        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogTechnology, 500);
      }, 500);
    })

    function eventlistenerTechnologyINPlayed() {
      if (vid.currentTime >= 3) {
        removePlaylisterns();
        vid.pause();
      }
    }

    function eventlistenerTechnologyOUTPlayed() {
      if (vid.currentTime >= 5) {
        removePlaylisterns();
        vid.pause();
      }
    }

    function closeDialogTechnology() {
      vid.currentTime = 4;
      vid.addEventListener('timeupdate', eventlistenerTechnologyOUTPlayed)
      vid.play()
      vid.classList.remove('zoom');
      window.setTimeout(toggleDialogTechnology, 500);
    }

    function toggleDialogTechnology() {

      let dialogComponents = document.querySelector('#achsspanner_technology');
      let closebutton = document.querySelector('#achsspanner_technology .control--close');
      let pagebody = document.querySelector('body');
      let scrollable = document.querySelector('#achsspanner_technology .modal-component__content');
      if (document.querySelector('#achsspannervideo').clientWidth > 900) {
        scrollable = document.querySelector('#achsspanner_technology .modal-component__content ul');
      }
      if (!dialogComponents.classList.contains('open')) {
        dialogComponents.classList.add('open');
        dialogComponents.classList.remove('close');
        pagebody.classList.add('dialog-components-open');
        closebutton.addEventListener('click', closeDialogTechnology);
   //     disableBodyScroll(scrollable);
      } else {
        dialogComponents.classList.add('class', 'closing');
        setTimeout(function () {
          dialogComponents.classList.remove('open');
          dialogComponents.classList.add('close');
          dialogComponents.classList.remove('class', 'closing');
          document.querySelector('#achsspanner .section__content').style.display = 'block';
          document.querySelector("#komponenten .buttonholder").classList.add('show');
          pagebody.classList.remove('dialog-components-open');
     //     enableBodyScroll(scrollable);
        }, 600);
      }
    }

    /* steifigkeit */

    document.querySelector("button[data-target=steifigkeit]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 6;
        vid.addEventListener('timeupdate', eventlistenerSteifigkeitINPlayed);
        vid.play();
        vid.classList.add('zoom');
        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogSteifigkeit, 500);
      }, 500);
    })

    function eventlistenerSteifigkeitINPlayed() {
      if (vid.currentTime >= 7) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function eventlistenerSteifigkeitOUTPlayed() {
      if (vid.currentTime >= 9.5) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function closeDialogSteifigkeit() {
      vid.currentTime = 8;
      vid.addEventListener('timeupdate', eventlistenerSteifigkeitOUTPlayed);
      vid.play();
      vid.classList.remove('zoom');
      window.setTimeout(toggleDialogSteifigkeit, 500);
    }

    function toggleDialogSteifigkeit() {

      let dialogComponents = document.querySelector('#achsspanner_steifigkeit');
      let closebutton = document.querySelector('#achsspanner_steifigkeit .control--close');
      let pagebody = document.querySelector('body');
      let scrollable = document.querySelector('#achsspanner_steifigkeit .modal-component__content');
      if (document.querySelector('#achsspannervideo').clientWidth > 900) {
        scrollable = document.querySelector('#achsspanner_steifigkeit .modal-component__content ul');
      }
      if (!dialogComponents.classList.contains('open')) {
        dialogComponents.classList.add('open');
        dialogComponents.classList.remove('close');
        pagebody.classList.add('dialog-components-open');
        closebutton.addEventListener('click', closeDialogSteifigkeit);
        //disableBodyScroll(scrollable);
      } else {
        dialogComponents.classList.add('class', 'closing');
        setTimeout(function () {
          dialogComponents.classList.remove('open');
          dialogComponents.classList.add('close');
          dialogComponents.classList.remove('class', 'closing');
          document.querySelector('#achsspanner .section__content').style.display = 'block';
          document.querySelector("#komponenten .buttonholder").classList.add('show');
          pagebody.classList.remove('dialog-components-open');
        //  enableBodyScroll(scrollable);
        }, 600);
      }
    }

    /* spannbereich */

    document.querySelector("button[data-target=spannbereich]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 11;
        vid.addEventListener('timeupdate', eventlistenerSpannbereichINPlayed);
        vid.play();
        vid.classList.add('zoom');

        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogSpannbereich, 500);
      }, 500);
    })

    function eventlistenerSpannbereichINPlayed() {

      if (vid.currentTime >= 12) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function eventlistenerSpannbereichOUTPlayed() {
      if (vid.currentTime >= 14) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function closeDialogSpannbereich() {
      vid.currentTime = 13;
      vid.addEventListener('timeupdate', eventlistenerSpannbereichOUTPlayed);
      vid.play();
      vid.classList.remove('zoom');
      window.setTimeout(toggleDialogSpannbereich, 500);
    }

    function toggleDialogSpannbereich() {

      let dialogComponents = document.querySelector('#achsspanner_spannbereich');
      let closebutton = document.querySelector('#achsspanner_spannbereich .control--close');
      let pagebody = document.querySelector('body');
      let scrollable = document.querySelector('#achsspanner_spannbereich .modal-component__content');
      if (document.querySelector('#achsspannervideo').clientWidth > 900) {
        scrollable = document.querySelector('#achsspanner_spannbereich .modal-component__content ul');
      }
      if (!dialogComponents.classList.contains('open')) {
        dialogComponents.classList.add('open');
        dialogComponents.classList.remove('close');
        pagebody.classList.add('dialog-components-open');
        closebutton.addEventListener('click', closeDialogSpannbereich);
       // disableBodyScroll(scrollable);
      } else {
        dialogComponents.classList.add('class', 'closing');
        setTimeout(function () {
          dialogComponents.classList.remove('open');
          dialogComponents.classList.add('close');
          dialogComponents.classList.remove('class', 'closing');
          document.querySelector('#achsspanner .section__content').style.display = 'block';
          document.querySelector("#komponenten .buttonholder").classList.add('show');
          pagebody.classList.remove('dialog-components-open');
         // enableBodyScroll(scrollable);
        }, 600);
      }
    }

    /* grundkoerper */

    document.querySelector("button[data-target=grundkoerper]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 15;
        vid.addEventListener('timeupdate', eventlistenerGrundkoerperINPlayed);
        vid.play();
        vid.classList.add('zoom');

        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogGrundkoerper, 500);
      }, 500);
    })

    function eventlistenerGrundkoerperINPlayed() {
      if (vid.currentTime >= 16.5) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function eventlistenerGrundkoerperOUTPlayed() {
      if (vid.currentTime >= 18) {
        removePlaylisterns();
        vid.pause();
      }
    }

    function closeDialogGrundkoerper() {
      vid.currentTime = 17;
      vid.addEventListener('timeupdate', eventlistenerGrundkoerperOUTPlayed);
      vid.play();
      vid.classList.remove('zoom');
      window.setTimeout(toggleDialogGrundkoerper, 500);
    }

    function toggleDialogGrundkoerper() {

      let dialogComponents = document.querySelector('#achsspanner_grundkoerper');
      let closebutton = document.querySelector('#achsspanner_grundkoerper .control--close');
      let pagebody = document.querySelector('body');
      let scrollable = document.querySelector('#achsspanner_grundkoerper .modal-component__content');
      if (document.querySelector('#achsspannervideo').clientWidth > 900) {
        scrollable = document.querySelector('#achsspanner_grundkoerper .modal-component__content ul');
      }
      if (!dialogComponents.classList.contains('open')) {
        dialogComponents.classList.add('open');
        dialogComponents.classList.remove('close');
        pagebody.classList.add('dialog-components-open');
        closebutton.addEventListener('click', closeDialogGrundkoerper);
        //disableBodyScroll(scrollable);
      } else {
        dialogComponents.classList.add('class', 'closing');
        setTimeout(function () {
          dialogComponents.classList.remove('open');
          dialogComponents.classList.add('close');
          dialogComponents.classList.remove('class', 'closing');
          document.querySelector('#achsspanner .section__content').style.display = 'block';
          document.querySelector("#komponenten .buttonholder").classList.add('show');
          pagebody.classList.remove('dialog-components-open');
          //enableBodyScroll(scrollable);
        }, 600);
      }
    }


    /* automation */

    document.querySelector("button[data-target=automation]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 23;
        vid.addEventListener('timeupdate', eventlistenerAutomationINPlayed);
        vid.play();
        vid.classList.add('zoom');

        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogAutomation, 500);
      }, 500);
    })

    function eventlistenerAutomationINPlayed() {
      if (vid.currentTime >= 24.75) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function eventlistenerAutomationOUTPlayed() {
      if (vid.currentTime >= 28) {
        removePlaylisterns();
        vid.pause();
      }

    }

    function closeDialogAutomation() {
      vid.currentTime = 25;
      vid.addEventListener('timeupdate', eventlistenerAutomationOUTPlayed);
      vid.play();
      vid.classList.remove('zoom');
      window.setTimeout(toggleDialogAutomation, 500);
    }

    function toggleDialogAutomation() {
      let dialogComponents = document.querySelector('#achsspanner_automation');
      let closebutton = document.querySelector('#achsspanner_automation .control--close');
      let pagebody = document.querySelector('body');
      let scrollable = document.querySelector('#achsspanner_automation .modal-component__content');
      if (document.querySelector('#achsspannervideo').clientWidth > 900) {
        scrollable = document.querySelector('#achsspanner_automation .modal-component__content ul');
      }
      if (!dialogComponents.classList.contains('open')) {
        dialogComponents.classList.add('open');
        dialogComponents.classList.remove('close');
        pagebody.classList.add('dialog-components-open');
        closebutton.addEventListener('click', closeDialogAutomation);
     //   disableBodyScroll(scrollable);
      } else {
        dialogComponents.classList.add('class', 'closing');
        setTimeout(function () {
          dialogComponents.classList.remove('open');
          dialogComponents.classList.add('close');
          dialogComponents.classList.remove('class', 'closing');
          document.querySelector('#achsspanner .section__content').style.display = 'block'
          document.querySelector("#komponenten .buttonholder").classList.add('show');
          pagebody.classList.remove('dialog-components-open');
    //      enableBodyScroll(scrollable);
        }, 600);
      }
    }

    /* nullpunktspannung */

    document.querySelector("button[data-target=nullpunktspannung]").addEventListener('click', function () {
      if(time) {
        clearTimeout(time);
      }
      time = setTimeout(() => {
        vid.currentTime = 19;
        vid.addEventListener('timeupdate', eventlistenerNullpunktspannungINPlayed);
        vid.play();
        vid.classList.add('zoom');

        document.querySelector('#achsspanner .section__content').style.display = 'none';
        document.querySelector("#komponenten .buttonholder").classList.remove('show');
        window.setTimeout(toggleDialogNullpunktspannung, 500);
      }, 500);
    })

    function eventlistenerNullpunktspannungINPlayed() {
          if (vid.currentTime >= 20) {
            removePlaylisterns();
            vid.pause();
          }

        }

    function eventlistenerNullpunktspannungOUTPlayed() {
      if (vid.currentTime >= 22) {
        removePlaylisterns();
        vid.pause();
      }
    }

    function closeDialogNullpunktspannung() {
          vid.currentTime = 21;
          vid.addEventListener('timeupdate', eventlistenerNullpunktspannungOUTPlayed);
          vid.play();
          vid.classList.remove('zoom');
          window.setTimeout(toggleDialogNullpunktspannung, 500);
        }

    function toggleDialogNullpunktspannung() {
          let dialogComponents = document.querySelector('#achsspanner_nullpunktspannung');
          let closebutton = document.querySelector('#achsspanner_nullpunktspannung .control--close');
          let pagebody = document.querySelector('body');
          let scrollable = document.querySelector('#achsspanner_nullpunktspannung .modal-component__content');
          if (document.querySelector('#achsspannervideo').clientWidth > 900) {
            scrollable = document.querySelector('#achsspanner_nullpunktspannung .modal-component__content ul')
          }
          if (!dialogComponents.classList.contains('open')) {
            setTimeout(function() {
              dialogComponents.classList.add('open');
              dialogComponents.classList.remove('close');
              pagebody.classList.add('dialog-components-open');
              closebutton.addEventListener('click', closeDialogNullpunktspannung);
            }, 1000);
         //   disableBodyScroll(scrollable);
          } else {
            dialogComponents.classList.add('class', 'closing');
            setTimeout(function () {
              dialogComponents.classList.remove('open');
              dialogComponents.classList.add('close');
              dialogComponents.classList.remove('class', 'closing');
              document.querySelector('#achsspanner .section__content').style.display = 'block'
              document.querySelector("#komponenten .buttonholder").classList.add('show');
              pagebody.classList.remove('dialog-components-open');
        //      enableBodyScroll(scrollable);
            }, 600);
          }
        }
  }
});





